<template>
    <b-form-group>
        <b-row>
            <b-col cols="12">
                <b-card>
                    <b-row>
                        <b-col cols="12" lg="6">
                            <b-form-group
                                id="field_name"
                                label="Nombre:"
                                label-for="field_name"
                            >
                                <b-form-input
                                    v-model="field_name"
                                    size="md"
                                    type="text"
                                    placeholder="Nombre del campo"
                                    name="field_name"
                                    id="field_name"
                                >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group
                                id="field_type"
                                label="Tipo:"
                                label-for="field_type"
                            >
                                <app-form-select-input
                                    v-model="field_type"
                                    :options="typeItems"
                                    required
                                ></app-form-select-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6">
                            <b-form-group
                                id="field_order"
                                label="Orden:"
                                label-for="field_order"
                            >
                                <b-form-input
                                    v-model="field_order"
                                    size="md"
                                    type="number"
                                    min="0"
                                    placeholder="Orden del campo"
                                    name="field_order"
                                    id="field_order"
                                >
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group
                                label="Obligatorio"
                                label-for="field_required"
                            >
                                <b-form-radio-group
                                    v-model="field_required"
                                    id="field_required"
                                >
                                    <b-form-radio :value="false" checked="true"
                                        >No</b-form-radio
                                    >
                                    <b-form-radio :value="true"
                                        >Si</b-form-radio
                                    >
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group
                                id="field_meta"
                                label="Meta:"
                                label-for="field_meta"
                            >
                                <app-form-textarea-input v-model="field_meta">
                                </app-form-textarea-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </b-form-group>
</template>
<script>
export default {
    props: {
        id: Number,
        type: {
            type: String,
            default: 'text',
        },
        name: {
            type: String,
            default: 'Nombre del campo',
        },
        required: {
            type: Boolean,
            default: false,
        },
        order: {
            type: String,
            default: '0',
        },
        meta: {
            type: String,
            default: '{}',
        },
    },
    data: () => ({
        value: '',
        field_name: '',
        field_type: '',
        field_required: 0,
        field_order: '0',
        field_meta: '',

        select_value: [],
        input_options: '',
        field_options: [],
        field_option_text: '',
        typeItems,
    }),
    computed: {
        isRequired() {
            return !!this.required
        },
        getId() {
            return 'dynamic_field_' + this.id.toString()
        },
        unique_select() {
            return ['unique_select'].includes(this.type)
        },
        multiple_select() {
            return ['multiple_select'].includes(this.type)
        },
        is_empty_option() {
            return (
                this.builder &&
                (this.unique_select || this.multiple_select) &&
                this.field_options.length == 0
            )
        },
        getTypeQuestion() {
            if (this.unique_select) {
                return 'de opción única'
            }
            if (this.multiple_select) {
                return 'de opción multiple'
            }
            return 'abierta'
        },
        validOptions() {
            return this.field_options.filter(item => item.order !== -1)
        },
    },
    methods: {
        addOption() {
            this.field_options.push({
                value: this.field_option_text,
                text: this.field_option_text,
                order: this.field_options.length,
            })
            this.field_option_text = ''
            this.$refs.field_option_text.$el.focus()
        },
        removeTag(index) {
            this.field_options[index].order = -1
        },
    },
    watch: {
        field_name(val) {
            this.$emit('changeName', { id: this.id, name: val })
        },
        field_type(val) {
            this.$emit('changeType', { id: this.id, type: val })
        },
        field_order(val) {
            this.$emit('changeOrder', { id: this.id, order: val })
        },
        field_meta(val) {
            this.$emit('changeMeta', { id: this.id, meta: val })
        },
        field_required(val) {
            this.$emit('changeRequired', { id: this.id, required: val })
        },

        //
        value(val) {
            this.$emit('input', [val])
        },
        select_value(val) {
            this.$emit('input', val)
        },
        field_options(val) {
            this.$emit('changeOptions', { id: this.id, options: val })
        },
    },
    created() {
        this.field_name = this.name
        this.field_type = this.type
        this.field_order = this.order
        this.field_meta = this.meta
        this.field_required = this.required

        this.field_options = this.answers
    },
}

const typeItems = [
    { name: 'Fecha', id: 'date' },
    { name: 'Fecha y hora', id: 'datetime' },
    { name: 'Lista', id: 'list' },
    { name: 'Número', id: 'number' },
    { name: 'Texto', id: 'text' },
    { name: 'Área de texto', id: 'text_area' },
    { name: 'Hora', id: 'time' },
]
</script>

<style scoped>
.filed {
    position: relative;
}

.field_label--builder {
    border-color: #bbb;
    border-radius: 5px;
}

.dynamic_field_tag {
    background-color: #ffffff;
    color: #6e707e;
    font-size: 1rem;
}
</style>
